import React, { useEffect, useMemo, useState } from "react"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  exportProviderIpsStock,
  getProviderIps,
  getProviderIpsStock,
  getProviderItemCategories,
  getProviderItems,
  getProviderProjects,
} from "store/provider-dashboard/provider-dashboard-action"
import ProviderDashboardComponent from "components/ProviderDashboard/ProviderDashboardComponent"
const ProviderDashboard = () => {
  document.title = "Dashboard"
  const [IpFilters, setIPFilters] = useState(null)

  const providerIpsStock = useSelector(
    state => state.providerDashboard.providerIpsStock
  )

  const dispatch = useDispatch()

  const user = useSelector(state => state.auth?.user)
  const defaultFilters = useMemo(() => {
    const ids = user?.item_categories
    return ids?.length ? { item_category_ids: ids } : {}
  }, [user?.item_categories])

  const onCategoryChange = category => {
    dispatch(getProviderItems(category || ""))
  }

  const onProviderIPsAdvancedSearchHandler = values => {
    setIPFilters(values)
  }

  const onProviderIPsStockExport = () => {
    dispatch(exportProviderIpsStock(IpFilters))
  }

  useEffect(() => {
    dispatch(getProviderIpsStock(defaultFilters))
    dispatch(getProviderIps())
    dispatch(getProviderItemCategories())
    dispatch(getProviderProjects())
  }, [dispatch, defaultFilters])

  return (
    <React.Fragment>
      <Breadcrumbs title={"Provider"} breadcrumbItem={"Dashboard"} />
      <ProviderDashboardComponent
        provIpsStock={providerIpsStock?.data?.data}
        onCategoryChange={onCategoryChange}
        onProviderIPsAdvancedSearchHandler={onProviderIPsAdvancedSearchHandler}
        onProviderIPsStockExport={onProviderIPsStockExport}
      />
    </React.Fragment>
  )
}

export default ProviderDashboard
